import type { EditionAwarenessContextType } from './edition-awareness-context';

export function isEligibleForManualFeatureOnboarding(
	context: EditionAwarenessContextType,
): boolean {
	const { edition, isInTrial, invoiceableStatus, userRoles, lastKnownTrial, product } = context;

	return Boolean(
		product === 'confluence' &&
		(edition === 'standard' || edition === 'premium') &&
		isInTrial &&
		invoiceableStatus === 'INVOICEABLE' &&
		userRoles?.includes('SITE_ADMIN') &&
		lastKnownTrial?.trialType === 'MANUAL_TRIAL',
	);
}
